<template>
  <div v-if="!isLoad">
    <div>
      <div class="columns is-justify-content-space-between mgb-0" v-if="!detail">
        <selecteur-action @handleAction="handleAction" class="column is-narrow"
                          :options='actions'
                          :placeholder='$t("general.placeHolder.groupedAction")'
                          :titleButton="'general.button.apply'"
                          :elementsSelectionnes="getAllEncartsSelected().length > 0">
        </selecteur-action>
        <div class="column is-narrow">
          <div class="button is-addOrEdit" @click="addEncarts()">
            {{ $t('produitPresse.encarts.actions.add') }}
          </div>
          <button class="button mgl-10px">
            <b-dropdown position="is-bottom-left">
              <b-icon icon="dots-vertical" slot="trigger" role="button" type="is-default">
              </b-icon>
              <b-dropdown-item @click="popUpFormatPresse = true">
                {{ $t('produitPresse.encarts.actions.appliquerFormatPresse') }}
              </b-dropdown-item>
            </b-dropdown>
          </button>
        </div>
      </div>
      <div v-else class="columns is-justify-content-end">
        <div class="column is-narrow is-align-self-center">
          <div class="lien has-text-right">
            <span class="is-cursor-pointer" @click="displayInactif = !displayInactif">
              {{ displayInactif
                ? $t('produitPresse.encarts.actions.displayEncartInactif',
                  { number: getInactifNumber })
                : $t('produitPresse.encarts.actions.masquerEncartInactif',
                  { number: getInactifNumber })
              }}
            </span>
          </div>
        </div>
        <div class="column is-narrow">
          <exportExcelButton
            :perm="permissions.exporter"
            :query="exportExcelQuery"/>
        </div>
      </div>
      <v-client-table class="overflow-x-auto min-height-50vw"
        :data="encarts"
        :columns="columns" :options="options"
        ref="encartsArray">
        <template slot="selected" slot-scope="props">
          <qd-checkbox v-model="props.row.selected" class="mgt-5px"
                      @input="updateValue(props.row, 'selected', props.index)">
          </qd-checkbox>
        </template>
        <template slot="reference" slot-scope="props">
          <b-input :value="props.row.reference"
           class="colonneMinWidth130px"
           disabled v-if="!detail">
          </b-input>
          <span v-else>{{ props.row.reference }}</span>
        </template>
        <template slot="libelle" slot-scope="props">
          <div
            v-if="!detail"
            class="fakeInput fakeDisabled min250px colonneWidth250px"
            v-html="formatBackToLineHtml(props.row.libelle)">
          </div>
          <b-tooltip
            v-else
            position="is-bottom"
            multilined>
            <div class="max250px min150px ellipsis"
              v-html="formatBackToLineHtml(props.row.libelle)">
            </div>
            <template v-slot:content>
              <div v-html="formatBackToLineHtml(props.row.libelle)"></div>
            </template>
          </b-tooltip>
        </template>
        <template slot="libelleComplementaire" slot-scope="props">
          <b-input
            v-if="!detail"
            class="min250px colonneWidth250px"
            v-model="props.row.libelleComplementaire"
            @input="updateValue(props.row, 'libelleComplementaire', props.index)"
            maxlength="255"
            :has-counter="false">
          </b-input>
          <b-tooltip
            v-else
            position="is-bottom"
            multilined>
            <div class="max250px min150px ellipsis"
              v-html="props.row.libelleComplementaire">
            </div>
            <template v-slot:content>
              <div v-html="props.row.libelleComplementaire"></div>
            </template>
          </b-tooltip>
        </template>
        <template slot="surfaceId" slot-scope="props">
          <b-select v-model="props.row.surfaceId" expanded v-if="!detail"
                    @input="updateValue(props.row, 'surfaceId', props.index)"
                    :disabled="!isDeletable(props.row.id)">
            <option v-for="surface in surfaces"
                    :value="surface.id"
                    :key="surface.id">
              {{ surface.libelle + ' / ' + surface.code + ' / ' + surface.ratio }}
            </option>
          </b-select>
          <span v-else>{{ getSurfaceById(props.row.surfaceId) }}</span>
        </template>
        <template slot="emplacementId" slot-scope="props">
          <parametre-autocomplete
              v-if="!detail"
              :key="props.row.id"
              v-model="props.row.emplacementId"
              :target="constantes.PARAMETRES_KEYS.emplacementPresse"
              expanded
              :disabled="!isDeletable(props.row.id)"
             @input="updateValue(props.row, 'emplacementId', props.index)"
             :customMapItem="mapEmplacement"
             field="libelleComplet"
           />
          <span v-else>{{ getEmplacementById(props.row.emplacementId) }}</span>
        </template>
        <template slot="couleurEncartId" slot-scope="props">
          <parametre-autocomplete
            v-if="!detail"
            :key="props.row.id"
            v-model="props.row.couleurEncartId"
            :target="constantes.PARAMETRES_KEYS.couleurEncart"
            @input="updateValue(props.row, 'couleurEncartId', props.index)"
            :custom-map-item="mapCouleurEncart"
            field="libelleComplet"
            expanded
            />
          <span v-else>{{ getCouleurById(props.row.couleurEncartId) }}</span>
        </template>
        <template slot="categorieOperation" slot-scope="props">
          <b-select
            v-if="!detail"
            v-model="props.row.categorieOperation"
            @input="updateValue(props.row, 'categorieOperation', props.index)"
            expanded>
            <option :value="null"></option>
            <option
              v-for="categorie in categorieOperations"
              :key="categorie.code"
              :value="categorie.code">
              {{ $t(categorie.libelle) }}
            </option>
          </b-select>
          <span v-else>{{ $t(getCategorieOperation(props.row.categorieOperation)) }}</span>
        </template>
        <template slot="largeur" slot-scope="props">
          <b-input v-model="props.row.largeur"
                   step="0.01" v-if="!detail"
                   type="number"
                   @input="updateValue(props.row, 'largeur', props.index)"></b-input>
          <span v-else>{{ props.row.largeur }}</span>
        </template>
        <template slot="hauteur" slot-scope="props">
          <b-input v-model="props.row.hauteur"
                   type="number" v-if="!detail"
                   step="0.01"
                   @input="updateValue(props.row, 'hauteur', props.index)"></b-input>
          <span v-else>{{ props.row.hauteur }}</span>
        </template>
        <template slot="dateDebut" slot-scope="props">
          <b-datepicker show-week-number v-if="!detail"
                        class="colonneMinWidth130px"
                        nearby-selectable-month-days
                        v-model="props.row.dateDebut"
                        icon="calendar-today"
                        @input="updateValue(props.row, 'dateDebut', props.index)"
                        :editable="true">
          </b-datepicker>
          <span v-else>{{ props.row.dateDebut | formatDate}}</span>
        </template>
        <template slot="dateFin" slot-scope="props">
          <b-datepicker show-week-number v-if="!detail"
                      class="colonneMinWidth130px"
                        nearby-selectable-month-days
                        v-model="props.row.dateFin"
                        icon="calendar-today"
                        position="is-bottom-left"
                        @input="updateValue(props.row, 'dateFin', props.index)"
                        :editable="true">
          </b-datepicker>
          <span v-else>{{ props.row.dateFin | formatDate}}</span>
        </template>
        <template slot="prixUnitaire" slot-scope="props">
          <b-input v-model="props.row.prixUnitaire"
                  class="colonneMinWidth130px"
                   type="number" v-if="!detail"
                   step="0.01"
                   @input="updateValue(props.row, 'prixUnitaire', props.index)"></b-input>
          <span v-else>{{ props.row.prixUnitaire | formatDevise }}</span>
        </template>
        <template slot="tauxTva" slot-scope="props">
          <b-select
            v-if="!detail"
            v-model="props.row.tauxTva"
            @input="updateValue(props.row, 'tauxTva', props.index)"
            expanded>
            <option
              v-for="tva in getRegimeTva(props.row)"
              :key="tva.tauxTva"
              :value="tva.tauxTva">
              {{ formatPercent(tva.tauxTva) }}
            </option>
          </b-select>
          <span v-else>{{ formatPercent(props.row.tauxTva) }}</span>
        </template>
        <template slot="actif" slot-scope="props">
          {{ $t(`general.${props.row.actif ? 'oui' : 'non'}`) }}
        </template>
        <template slot="delete" slot-scope="props">
          <a @click="deleteEncarts(props.index)"
             :class="isDeletable(props.row.id) ? '' : 'disabled'">
            <b-icon class="mgt-5px" icon="delete-forever" type="is-danger"
            ></b-icon>
          </a>
        </template>
      </v-client-table>
    </div>
    <b-modal
      v-model="popUpFormatPresse"
      has-modal-card class="modal">
      <pop-up-type-format-presse @apply="applyTypeFormatPresse">
      </pop-up-type-format-presse>
    </b-modal>
    <b-modal
      v-model="popUpCategorieOperation"
      class="modal"
      has-modal-card>
      <pop-up-categorie-operation @apply="applyTypeCategorieOperation"/>
    </b-modal>
    <b-modal
      v-model="popupDupplicationEncart"
      class="modal"
      has-modal-card>
        <popup-dupplication-encart
          :title="$t('produitPresse.encarts.popUpDuplication.title')"
          :label="$t('produitPresse.encarts.popUpDuplication.label')"
          @dupliquer="duplicationEncarts"
        />
    </b-modal>
  </div>
</template>

<script>
import selecteurAction from '@/components/general/selecteurAction';
import PopUpTypeFormatPresse from '@/components/catalogue/produitGeneralPresse/edition/encarts/p_typeFormatPresse';
import PopUpCategorieOperation from '@/components/catalogue/produitGeneralPresse/edition/p_categorieOperation';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import cloneDeep from 'lodash/cloneDeep';
import {
  NO_PER_PAGE_VALUE,
  RESULTS_PER_PAGE,
  SORT_ICON,
  TEXTS,
} from '@/configuration/clientTableConf';
import * as produitConf from '@/configuration/catalogue/produitConf';
import { createNamespacedHelpers } from 'vuex';
import genererEncart from '@/services/presse/presse/genererEncart';
import {
  ACTION_ARCHIVER,
  ACTION_DESARCHIVER,
  ACTION_DUPLICATION,
  ACTION_SUPPRESSION,
  ACTION_CATEGORIE_OPERATION,
} from '@/configuration/presse/produitSalon/produitSalonConfiguration';
import messageErreur from '@/services/general/messageErreur';
import { columnsSplice } from '@/services/general/columns';
import formatBackToLineHtml from '@/services/general/formatBackToLineHtml';
import formatPercent from '@/services/general/filters/formatPercent';
import { getAll } from '@/api/ligneCommande';
import { SENS_VENTE } from '@/configuration/devisConf';
import { EXPORT_EXCEL_ENCARTS_PRODUIT } from '@/configuration/presse/produitPresse/produitPresseConf';
import PopupDupplicationEncart from '@/components/catalogue/produitGeneralPresse/edition/encarts/p_dupplicationEncart';
import exportExcelButton from '@/components/general/button/exportExcelButton';
import ParametreAutocomplete from '@/components/general/autocomplete/parametreAutocomplete';

const Parametres = createNamespacedHelpers('parametres');
const Societe = createNamespacedHelpers('societe');

export default {
  name: 'CatalogueProduitGeneralPresseEditEncarts',
  props: {
    produit: {
      type: Object,
      required: true,
    },
    sousProduit: {
      type: Object,
      required: true,
    },
    detail: {
      type: Boolean,
      required: false,
    },
    permissions: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      actions: [
        { action: ACTION_DUPLICATION, translation: 'produitPresse.encarts.actions.dupliquer' },
        { action: ACTION_ARCHIVER, translation: 'produitPresse.encarts.actions.archiver' },
        { action: ACTION_DESARCHIVER, translation: 'produitPresse.encarts.actions.desarchiver' },
        { action: ACTION_SUPPRESSION, translation: 'produitPresse.encarts.actions.supprimer' },
        { action: ACTION_CATEGORIE_OPERATION, translation: 'produitPresse.encarts.actions.categorieOperation' },
      ],
      lignesVente: [],
      popUpFormatPresse: false,
      popUpCategorieOperation: false,
      popupDupplicationEncart: false,
      displayInactif: true,
      isLoad: false,
      categorieOperations: produitConf.CATEGORIE_OPERATION,
      formatBackToLineHtml,
      formatPercent,
      constantes: {
        PARAMETRES_KEYS,
      },
    };
  },
  components: {
    selecteurAction,
    PopUpTypeFormatPresse,
    PopUpCategorieOperation,
    PopupDupplicationEncart,
    exportExcelButton,
    ParametreAutocomplete,
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    surfaces() {
      return this.parametre(PARAMETRES_KEYS.surface);
    },
    emplacements() {
      return this.parametre(PARAMETRES_KEYS.emplacementPresse);
    },
    couleurs() {
      return this.parametre(PARAMETRES_KEYS.couleurEncart);
    },
    getInactifNumber() {
      return this.sousProduit.encarts.filter((encart) => { return encart.actif === false; }).length;
    },
    allEncartsSelected() {
      return this.getAllEncartsSelected().length === this.sousProduit.encarts.length;
    },
    iconSelectTotal() {
      if (this.allEncartsSelected) {
        return 'checkbox-multiple-marked-outline';
      }
      return 'checkbox-multiple-blank-outline';
    },
    columns() {
      const columns = [
        'selected', 'reference', 'libelle', 'libelleComplementaire', 'surfaceId', 'emplacementId', 'couleurEncartId', 'categorieOperation',
        'largeur', 'hauteur', 'dateDebut', 'dateFin', 'prixUnitaire', 'tauxTva',
        'actif', 'delete',
      ];
      if (this.detail) {
        columnsSplice(columns, 'selected');
        columnsSplice(columns, 'delete');
      }
      return columns;
    },
    options() {
      const texts = cloneDeep(TEXTS);
      texts.count = '';
      return {
        sortIcon: SORT_ICON,
        headings: {
          reference: this.$t('produitPresse.encarts.tab.reference'),
          libelle: this.$t('produitPresse.encarts.tab.libelle'),
          libelleComplementaire: this.$t('produitPresse.encarts.tab.libelleComplementaire'),
          surfaceId: this.$t('produitPresse.encarts.tab.surface'),
          emplacementId: this.$t('produitPresse.encarts.tab.emplacement'),
          couleurEncartId: this.$t('produitPresse.encarts.tab.couleurEncart'),
          categorieOperation: this.$t('produitPresse.encarts.tab.categorieOperation'),
          largeur: this.$t('produitPresse.encarts.tab.largeur'),
          hauteur: this.$t('produitPresse.encarts.tab.hauteur'),
          dateDebut: this.$t('produitPresse.encarts.tab.dateDebut'),
          dateFin: this.$t('produitPresse.encarts.tab.dateFin'),
          prixUnitaire: this.$t('produitPresse.encarts.tab.prixUnitaire'),
          tauxTva: this.$t('produitPresse.encarts.tab.tauxTva'),
          actif: this.$t('produitPresse.encarts.tab.actif'),
          delete: '',
          selected: (h) => {
            return h(
              'a', {
                attrs: {
                  class: 'pointer',
                },
                on: {
                  click: () => {
                    const allSelected = this.allEncartsSelected;
                    this.sousProduit.encarts.forEach(item => {
                      item.selected = !allSelected;
                    });
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: this.iconSelectTotal,
                  },
                }),
              ],
            );
          },
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        texts: texts,
        customSorting: {
          surfaceId: (ascending) => {
            return (encartA, encartB) => {
              if (ascending) {
                return encartA.surface.ratio - encartB.surface.ratio;
              }
              return encartB.surface.ratio - encartA.surface.ratio;
            };
          },
        },
        columnsClasses: {
          delete: 'colonneSelected',
          selected: 'colonneSelected',
          libelle: 'colonneWidth250px',
          libelleComplementaire: 'colonneWidth250px',
          reference: 'colonneWidth130px',
          surfaceId: 'colonneMinWidth-150px',
          emplacementId: 'colonneMinWidth-150px',
          couleurEncartId: 'colonneMinWidth-150px',
          dateDebut: 'colonneWidth130px',
          dateFin: 'colonneWidth130px',
          prixUnitaire: 'colonneWidth130px',
          tauxTva: 'colonneMinWidth-100px',
        },
        sortable: this.detail ? ['reference', 'libelle', 'libelleComplementaire', 'surfaceId', 'emplacementId', 'couleurEncartId', 'largeur', 'hauteur', 'dateDebut', 'dateFin', 'prixUnitaire', 'tauxTva', 'actif'] : [],
      };
    },
    encarts() {
      if (this.displayInactif) {
        return this.sousProduit.encarts
          .filter(el => el.actif === this.displayInactif);
      }
      return this.sousProduit.encarts;
    },
    exportExcelQuery() {
      return {
        typeDonnee: EXPORT_EXCEL_ENCARTS_PRODUIT,
        typeExport: null,
        filtres: {
          query: {
            produitId: this.produit.id,
            displayInactif: this.displayInactif,
          },
        },
      };
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    getAllEncartsSelected() {
      return this.sousProduit.encarts.filter((el) => {
        return el.selected;
      });
    },
    isDeletable(encartId) {
      return this.lignesVente.find((el) => el.produitId === encartId) === undefined;
    },
    getCouleurById(id) {
      const find = this.couleurs.find((el) => el.id === id);
      return find?.libelle;
    },
    getCategorieOperation(value) {
      const find = this.categorieOperations.find((el) => el.code === value);
      return find?.libelle;
    },
    getSurfaceById(id) {
      const find = this.surfaces.find((el) => el.id === id);
      return find?.libelle;
    },
    getEmplacementById(id) {
      const find = this.emplacements.find((el) => el.id === id);
      return find?.libelle;
    },
    getRegimeTva(encart) {
      return this.parametre(PARAMETRES_KEYS.regimeTva).filter((tva) => {
        return tva.actif || encart.tauxTva === tva.tauxTva;
      });
    },
    handleAction(type) {
      switch (type) {
        case ACTION_SUPPRESSION:
          this.sousProduit.encarts.forEach((el) => {
            if (!this.isDeletable(el.id)) el.selected = false;
          });
          this.sousProduit.encarts = this.sousProduit.encarts
            .filter((el) => !el.selected);
          break;
        case ACTION_DUPLICATION:
          this.popupDupplicationEncart = true;
          break;
        case ACTION_ARCHIVER:
          this.archiverEncarts(false);
          break;
        case ACTION_DESARCHIVER:
          this.archiverEncarts(true);
          break;
        case ACTION_CATEGORIE_OPERATION:
          this.popUpCategorieOperation = true;
          break;
        default:
          break;
      }
    },
    applyTypeFormatPresse(typeFormatPresse) {
      if (typeFormatPresse) {
        typeFormatPresse.typeFormatPresseLignes.forEach(el => {
          this.sousProduit.encarts.push(genererEncart(
            el.surfaceId,
            el.emplacementId,
            el.couleurEncartId,
            el.largeur,
            el.hauteur,
          ));
          this.generationLibelleProduit(this.sousProduit.encarts.length - 1);
        });
      }
    },
    applyTypeCategorieOperation(categorieOperation) {
      this.sousProduit.encarts.filter((el) => el.selected).forEach((el) => {
        el.categorieOperation = categorieOperation;
      });
    },
    addEncarts() {
      this.sousProduit.encarts.unshift(genererEncart());
      this.generationLibelleProduit(this.sousProduit.encarts.length - 1);
    },
    archiverEncarts(state) {
      this.sousProduit.encarts.filter((el) => el.selected).forEach((el) => {
        el.actif = state;
      });
    },
    deleteEncarts(index) {
      this.sousProduit.encarts.splice(index - 1, 1);
    },
    updateValue(row, key, index) {
      if (index) {
        this.$set(this.sousProduit.encarts[index - 1], key, row[key]);
        this.generationLibelleProduit(index - 1);
      }
    },
    generationLibelleProduit(index) {
      const encart = this.sousProduit.encarts[index];
      const libellePattern = [];
      const surface = this.surfaces.find((el) => el.id === encart.surfaceId);
      const couleur = this.couleurs.find((el) => el.id === encart.couleurEncartId);
      const emplacement = this.emplacements.find((el) => el.id === encart.emplacementId);
      if (surface) libellePattern.push(surface.libelle);
      if (couleur) libellePattern.push(couleur.libelle);
      if (emplacement) libellePattern.push(emplacement.libelle);
      if (encart.largeur) libellePattern.push('L ' + encart.largeur);
      if (encart.hauteur) libellePattern.push('H ' + encart.hauteur);
      encart.libelle = libellePattern.join(' - ');
      encart.libelle = [encart.libelle, encart.libelleComplementaire].join('\n');
      if (encart.libelle.length > 255) encart.libelle = encart.libelle.slice(0, 255);
      this.sousProduit.encarts.splice(index, 1, encart);
    },
    duplicationEncarts(nombre = 1) {
      const newEncarts = cloneDeep(this.sousProduit.encarts.filter((el) => {
        return el.selected;
      }));
      newEncarts.forEach((el) => {
        el.selected = false;
        if (el.id) delete el.id;
      });
      for (let i = 0; i < nombre; i += 1) {
        this.sousProduit.encarts = this.sousProduit.encarts.concat(cloneDeep(newEncarts));
      }
    },
    mapEmplacement(item) {
      return {
        id: item.id,
        code: item.code,
        libelle: item.libelle,
        libelleComplet: `${item.libelle} / ${item.code}`,
        actif: item.actif === undefined ? true : item.actif,
      };
    },
    mapCouleurEncart(item) {
      return {
        id: item.id,
        code: item.code,
        libelle: item.libelle,
        libelleComplet: `${item.libelle} / ${item.code}`,
        actif: item.actif === undefined ? true : item.actif,
      };
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    this.isLoad = true;
    if (!this.detail) this.displayInactif = false;
    try {
      await this.loadParametres([
        PARAMETRES_KEYS.surface,
        PARAMETRES_KEYS.emplacementPresse,
        PARAMETRES_KEYS.couleurEncart,
        PARAMETRES_KEYS.regimeTva,
      ]);
      this.lignesVente = (await getAll({
        query: {
          societeId: this.societeActiveId,
          produitsIds: this.produit.produitPresse.encarts.map((e) => e.id),
          sens: SENS_VENTE,
        },
      })).data.result.items;
      this.isLoad = false;
      loadingComponent.close();
    } catch (e) {
      this.isLoad = false;
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>

<style scoped>

</style>
